import { render, staticRenderFns } from "./CardFooter.vue?vue&type=template&id=6d4bd8f9&"
import script from "./CardFooter.vue?vue&type=script&lang=js&"
export * from "./CardFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports